import React, { useState } from "react"

import StrmrmfsFoods from "./StrmrmfsFoods"
import StrmrmfsCategories from "./StrmrmfsCategories"
import { Spinner } from "components"
import classes from "./index.module.scss"

const StrmrmFoodsSearch = props => {
  const {
    categories,
    selectedFoodOptions,
    setSelectedFoodOptions,
    sourceBranchId
  } = props

  const [selectedCategory, setSelectedCategory] = useState(null)

  const loading = categories === null

  return (
    <div className={classes["container"]}>
      {!loading
        ?
        <div className={classes["row"]}>
          <StrmrmfsCategories
            categories={categories}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
          />
          <StrmrmfsFoods
            selectedFoodOptions={selectedFoodOptions}
            setSelectedFoodOptions={setSelectedFoodOptions}
            selectedCategory={selectedCategory}
            sourceBranchId={sourceBranchId}
          />
        </div>
        :
        <div className={classes["loading"]}>
          <Spinner color="var(--color-primary)" />
        </div>
      }
    </div>
  )
}

export default React.memo(StrmrmFoodsSearch)